import React, { useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import Logo from '@atoms/Logo/Logo';
import { useLocale } from '@hooks';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Button from '@atoms/Button/Button';
import NavMobile from './NavMobile';
import { SubMenu } from './HeaderNav';

interface Props {
    location?: string;
    theme: 'white' | 'dark';
    list: SubMenu[];
    headerIsFixed: boolean;
}

const HeaderNavMobile: React.FC<Props> = ({
    location,
    theme,
    list,
    headerIsFixed,
}) => {
    const [isShown, setIsShown] = useState(false);
    const { getAppLinkWithCurrentLang } = useLocale();
    const { t } = useTranslation();

    const toggleMenu = () => {
        setIsShown(!isShown);
    };

    return (
        <>
            <div
                className={`HeaderNavV2 ${
                    headerIsFixed ? 'is-fixed' : ''
                } theme-${theme} g_show_from_tablet_portrait`}
            >
                <div className="HeaderNav--inner">
                    <div className="HeaderNav--item-mobile">
                        <div className='HeaderNav--leftItemWrapper'>
                            <div
                                className={`HeaderNav--item--menuBtn${
                                    isShown ? 'is-open' : ''
                                }`}
                                onClick={toggleMenu}
                            >
                                {!isShown && <FiMenu />}
                            </div>

                            {isShown ? (
                                <></>
                            ) : (
                                <div className="HeaderNav--item--logo is-header-fixed">
                                    <Logo theme={theme} />
                                </div>
                            )}

                        </div>


                        {isShown ? (
                            <></>
                        ) : (
                            <>
                                <div className="HeaderNav--item--logo is-header-static">
                                    <Logo theme={theme} />
                                </div>

                                <div>
                                    {!headerIsFixed && (
                                        <a
                                            href={getAppLinkWithCurrentLang(
                                                'https://app.aepsy.com/login'
                                            )}
                                        >
                                            <Button
                                                label={t('nav.label.login')}
                                                variant="outlined"
                                                theme="white"
                                                size="xxs"
                                                radius="xxs"
                                            />
                                        </a>
                                    )}

                                    <div className="HeaderNav--item HeaderNav--item--cta">
                                        {location &&
                                        location.includes('for-therapists') ? (
                                            <AnchorLink
                                                offset={() => 120}
                                                href="#provider-signup"
                                            >
                                                <Button
                                                    label={t(
                                                        'join.as.psychologist.cta.label'
                                                    )}
                                                    size="s"
                                                    theme="pink-gradient"
                                                    classes="HeaderNav--cta-desktop"
                                                />
                                            </AnchorLink>
                                        ) : (
                                            <a
                                                href={
                                                    process.env
                                                        .GATSBY_START_FULL_FUNNEL_URL
                                                }
                                            >
                                                <Button
                                                    label={t('button.get.started')}
                                                    size="s"
                                                    theme="pink-gradient"
                                                    classes="HeaderNav--cta-desktop"
                                                />
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <NavMobile list={list} isShown={isShown} onClose={toggleMenu} />
            </div>
        </>
    );
};

export default HeaderNavMobile;
